import SiteView from './SiteView';
import './SiteView.scss';

export default SiteView;
